"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_NAME_KEY = void 0;
exports.FORM_NAME_KEY = 'data-form';
